var Vue = require('vue');
var Multiselect = require('vue-bootstrap').Multiselect;

module.exports = function() {

  function displayFormElements(type) {
    $('.discount-type').addClass('hidden');
    $('.discount-type-' + type).removeClass('hidden');
  }

  $('select#type').on('change', function() {
    displayFormElements($(this).val());
  });

  displayFormElements($('select#type').val());

  new Vue({
    el: '#category-selector',
    components: {
      'multiselect': Multiselect
    }
  });

  // Whenever a category selection is made (aka, all, or select), we need to show the appropriate container
  var categorySelection = function () {
    var value = $('input[name=categoryOption]:checked').val();

    if (value == 'select') {
      $('#categorySelectionContainer').show();
    } else {
      $('#categorySelectionContainer').hide();
    }
  };

  $('input[name=categoryOption]').change(categorySelection);

  categorySelection();

};
